/**
 * Super 端 API 根地址 — 前端自适应，不依赖 Nginx 反代
 * - 本地开发（localhost / 127.0.0.1）：http://localhost:4000
 * - 生产（含 a.xingyiai.com）：https://s.xingyiai.com
 * - 可选：npm run dev:prod 临时连生产 API
 */
const LOCAL_API = 'http://localhost:4000'
const PROD_API = 'https://s.xingyiai.com'

function isLocalHost() {
  const h = window.location.hostname
  return h === 'localhost' || h === '127.0.0.1'
}

export function getApiBase() {
  if (isLocalHost()) {
    const fromEnv = String(
      import.meta.env.VITE_API_BASE || import.meta.env.VITE_API_BASE_URL || ''
    )
      .trim()
      .replace(/\/$/, '')
    if (fromEnv) return fromEnv
    return LOCAL_API
  }
  return PROD_API
}

/** 绝对 URL，避免相对 /api 误打到 a.xingyiai.com */
export function buildApiUrl(path) {
  if (!path) return getApiBase()
  if (/^https?:\/\//i.test(path)) return path

  const p = path.startsWith('/') ? path : `/${path}`
  let base = getApiBase()
  if (base.endsWith('/api')) base = base.slice(0, -4)
  return `${base}${p}`
}

export default {
  getApiBase,
  buildApiUrl
}
